module.exports = __webpack_public_path__ + "img/UP_SKOOL_LOGO.5b4bdd17.png";